<template>
  <div class="attachment_preview_show" v-if="attachments">
    <div class="prview_example">
      <div
        class="preview_example_inner"
        v-for="(attachment, index) in attachments"
        :key="'attachment_' + index"
        @click.prevent="
          showDownloadFile(attachment.file_path, attachment.file_extension)
        "
      >
        <template
          v-if="
            ['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(
              attachment.file_extension
            )
          "
        >
          <img :src="attachment.file_path" />
        </template>
        <template v-if="['pdf'].includes(attachment.file_extension)">
          <embed :src="attachment.file_path" width="150" />
        </template>
        <template
          v-if="
            ['xls', 'xlsx', 'xlm', 'xla', 'xlc', 'xlt', 'xlw', 'csv'].includes(
              attachment.file_extension
            )
          "
        >
          <i class="fas fa-file-excel fa-10x"></i>
        </template>
        <template v-if="['docx'].includes(attachment.file_extension)">
          <i class="fas fa-file-word fa-10x"></i>
        </template>
        <template v-if="['zip'].includes(attachment.file_extension)">
          <i class="fas fa-file-archive fa-10x"></i>
        </template>
        <div class="preview_text">
          <span>{{ attachment.original_file_name }}</span>
        </div>
        <div class="preview_text_details">
          <div>{{ attachment.original_file_name }}</div>
          <div>{{ generateFileSize(attachment.original_size) }}</div>
          <div>
            <span
              @click.prevent="
                downloadFile(
                  attachment.file_path,
                  attachment.original_file_name
                )
              "
              ><i class="lni lni-download"></i
            ></span>
          </div>
        </div>
      </div>
    </div>
    <BaseModal
      v-if="showFileModal"
      title="File Preview"
      size="modal_850p"
      :closeModal="hideFileModal"
    >
      <FileModal :filePath="filePath" @closeModal="hideFileModal" />
    </BaseModal>
  </div>
</template>
<script>
import FileModal from './FileModal';
import BaseModal from '@/components/BaseModal.vue';

export default {
  name: 'attachment-preview-component',
  components: { BaseModal, FileModal },
  data() {
    return {
      showFileModal: false,
      filePath: '',
    };
  },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
  },
  mounted() {},
  methods: {
    generateFileSize(size) {
      let formatted_size = '';
      if (size / (1024 * 1024) >= 1) {
        formatted_size = (size / (1024 * 1024)).toFixed(2) + ' MB';
      } else {
        formatted_size = (size / 1024).toFixed(2) + ' KB';
      }
      return formatted_size;
    },
    downloadFile(filePath, originalFileName) {
      const a = document.createElement('a');
      a.href = filePath;
      // let filenameArr  = filePath.split('/');
      // let filename = filenameArr[filenameArr.length-1];
      // a.download = filename;
      a.download = originalFileName;
      a.style.display = `none`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    showDownloadFile(filePath, ext) {
      console.log('sdsdsd');
      if (['gif', 'png', 'jpg', 'jpeg', 'JPG', 'pdf'].includes(ext)) {
        this.filePath = filePath;
        this.showFileModal = true;
      }
    },
    hideFileModal() {
      this.filePath = '';
      this.showFileModal = false;
    },
  },
};
</script>
<style scoped>
.preview_example_inner {
  height: 150px !important;
}
.attachment_preview_show {
  padding: 10px 0px;
  .prview_example {
    display: flex;
    gap: 15px;
    .preview_example_inner {
      width: 150px;
      height: 115px;
      position: relative;
      &:hover {
        .preview_text_details {
          opacity: 1 !important;
        }
      }
      .preview_text {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: rgba(18, 18, 18, 0.5);
        color: #fff;
        padding: 5px;
      }
      .preview_text_details {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgb(0, 0, 0);
        color: #fff;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        opacity: 0;
        span {
          margin-right: 5px;
          margin-top: 5px;
          cursor: pointer;
        }
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
